import { homeConstants } from "../constants";

const uuidv4 = () => {
  return "4xxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 8) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(4);
  });
};

/*
use this type of reset types
  completeReset
  productReset
  insuranceReset
  dosageReset
  quantityReset
  zipCodeReset
*/
export default function (
  state = {
    selectedProduct: "",
    resetId: "",
    resetInfo: {
      type: "",
    },
    selectedDosage: 0,
  },
  action
) {
  switch (action.type) {
    case homeConstants.SELECTED_PRODUCT:
      return {
        ...state,
        selectedProduct: action.product,
      };
    case homeConstants.SELECTED_DOSAGE:
      return {
        ...state,
        selectedDosage: action.data,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        resetId: uuidv4(),
        resetInfo: {
          type: action.data,
          id: uuidv4(),
        },
      };
    default:
      return state;
  }
}
